
import { Component, Emit, Prop, Watch } from 'vue-property-decorator';
import VColumnSelect from '@/components/shared/table/VColumnSelect.vue';
import articleHeaders from './headers';
import typeSortByPrice from './sortByPrice';
import typeSortByVisibility from './sortByVisibility';
import { ColumnHeader } from '@/interfaces/components/ColumnHeader';
import VTable from '@/components/shared/table/VTable.vue';
import { Article } from '@/interfaces/models/Article';
import { Category } from '@/interfaces/models/Category';
import { Permission } from '@/enums/Permission';
import _ from 'lodash';
import { Venue } from '@/interfaces/models/Venue';
import { namespace } from 'vuex-class';
import VItemSelect from '@/components/shared/table/VItemSelect.vue';
import { mixins } from 'vue-class-component';
import { EditArticle as EditArticleMixin } from '@/mixins/EditArticle';
import Filter from '@/interfaces/api/Filter';
import cookie from 'js-cookie';
import { RoleType } from '../../enums/RoleType';
import { Tag } from '@/interfaces/models/Tag';
import { decimalAdjust } from '@/util/helper';
import { TuRRoleType } from '@/enums/TuRRoleType';
import { SubwayRoleType } from '@/enums/SubwayRoleType';

const foodcard = namespace('foodcard');

@Component({
  components: { VItemSelect, VTable, VColumnSelect },
})
export default class ArticleTable extends mixins(EditArticleMixin) {
  public editDialog: any = {
    isVisible: false,
    value: null,
    name: '',
    original: null,
  };

  public editTaxTakeawayDialog: any = {
    isVisible: false,
    value: null,
    name: '',
    original: null,
  };

  private defaultSetOfColumns = ['isActive', 'number'];

  get accessibleHeaders() {
    return articleHeaders.filter((c: ColumnHeader) => {
      if (
        c.value === 'isControlArticle' &&
        this.$can(Permission.ARTICLE_CONTROL_ACTIVATE) &&
        this.$can(Permission.ARTICLE_CONTROL_DEACTIVATE)
      ) {
        if (Object.values(TuRRoleType).includes(cookie.get('role') as TuRRoleType)) {
          c.default = false;
        }

        return true;
      }

      if (Object.values(SubwayRoleType).includes(cookie.get('role') as SubwayRoleType) && c.type === 'priceByType') {
        c.default = true;
      }
      if (cookie.get('role') === RoleType.FE045_OP && c.value === 'isActive') {
        c.default = true;
      }
      if (cookie.get('role') === RoleType.VENUE && this.defaultSetOfColumns.includes(c.value)) {
        c.default = true;
      }
      if (
        Object.values(TuRRoleType).includes(cookie.get('role') as TuRRoleType) &&
        this.defaultSetOfColumns.includes(c.value)
      ) {
        c.default = true;
      }
      return c.value !== 'isControlArticle';
    });
  }
  @Prop({ type: Array, required: true }) public items!: Article[];
  @Prop({ type: Number, required: true }) public total!: number;
  @Prop({ type: Array, required: true }) public categories!: Category[];
  @Prop({ type: Array, required: false }) public tags!: Tag[];

  @foodcard.Action('uploadArticleImage') public uploadImage!: any;
  @foodcard.Action('uploadArticleIcon') public uploadIcon!: any;
  @foodcard.Action('uploadArticleBanner') public uploadBanner!: any;

  @foodcard.State('articleFilter') public articleFilter!: Filter;

  public $refs!: {
    vTable: InstanceType<typeof VTable> & { vTable: any };
  };

  public sourceHeaders = this.accessibleHeaders;
  public sourceTypePrice = typeSortByPrice;
  public sourceTypeVisibility = typeSortByVisibility;
  public search = '';
  public number = '';
  public headers: ColumnHeader[] = this.accessibleHeaders.filter((c: ColumnHeader) => c.default);
  public category: string | null = '';

  public onChangeSearch = _.debounce((searchTerm: any) => {
    this.$refs.vTable.resetPagination();
    this.$emit('search', { search: searchTerm });
  }, 500);

  public handleSortPriceType(event: string) {
    this.$refs.vTable.resetPagination();
    this.$emit('search', { priceSort: event });
  }

  public handleSortVisibilityType(event: string | undefined) {
    this.$refs.vTable.resetPagination();
    if (event === undefined) {
      this.$emit('search', delete this.articleFilter['filterVisible']);
      return;
    }
    this.$emit('search', { filterVisible: event });
  }
  public mounted() {
    /* if (this.$route && this.$route.query && this.$route.query.category) {
      this.category = this.$route.query.category as string;
    } else if (this.categories && this.categories.length > 0) {
      this.category = this.categories[0]._id;
    }*/
  }

  public edit(item: Article) {
    if (this.$can(Permission.ARTICLE_UPDATE)) {
      this.$emit('edit', { id: item._id, category: item.category });
    } else {
      this.$emit('simple-edit', { id: item._id, category: item.category });
    }
  }

  public editModal(event: { header: ColumnHeader; item: any }) {
    if (event.item) {
      this.editDialog.isVisible = true;
      this.editDialog.name = event.header.value;
      this.editDialog.original = { ...event.item };
      this.editDialog.value = event.item[event.header.value];
    }
  }

  public editTaxTakeawayModal(event: { header: ColumnHeader; item: any }) {
    if (event.item) {
      this.editTaxTakeawayDialog.isVisible = true;
      this.editTaxTakeawayDialog.name = event.header.value;
      this.editTaxTakeawayDialog.original = { ...event.item };
      this.editTaxTakeawayDialog.value = event.item[event.header.value]?.$numberDecimal;
    }
  }

  public taxTakeawayToPercent(tax: { $numberDecimal: number }) {
    if (tax && tax?.$numberDecimal?.toString() === '-1') {
      return '';
    }
    if (tax && tax.$numberDecimal) {
      const taxNumber = Number(tax.$numberDecimal);
      return `${decimalAdjust('round', taxNumber * 100, -1)}%`;
    }
    return '';
  }

  get taxes() {
    return [
      { value: '0.20', text: '20%' },
      { value: '0.19', text: '19%' },
      { value: '0.16', text: '16%' },
      { value: '0.10', text: '10%' },
      { value: '0.085', text: '8.5%' },
      { value: '0.081', text: '8.1%' },
      { value: '0.07', text: '7%' },
      { value: '0.077', text: '7.7%' },
      { value: '0.055', text: '5.5%' },
      { value: '0.026', text: '2.6%' },
      { value: '0.025', text: '2.5%' },
      { value: '0.021', text: '2.1%' },
      { value: '0', text: '0%' },
      { value: '-1', text: 'default' },
    ];
  }

  public saveCellValue() {
    const data = {
      original: this.editDialog.original,
      field: this.editDialog.name,
      value: this.editDialog.value,
    };
    this.$emit('edited', data);
    this.stopEditing();
  }

  public saveTaxTakeawayCellValue() {
    const data = {
      original: this.editTaxTakeawayDialog.original,
      field: this.editTaxTakeawayDialog.name,
      value: this.editTaxTakeawayDialog.value,
    };
    this.$emit('edited', data);
    this.stopTaxTakeawayEditing();
  }

  public stopEditing() {
    this.editDialog.isVisible = false;
    this.editDialog.value = null;
    this.editDialog.original = null;
    this.editDialog.name = '';
  }

  public stopTaxTakeawayEditing() {
    this.editTaxTakeawayDialog.isVisible = false;
    this.editTaxTakeawayDialog.value = null;
    this.editTaxTakeawayDialog.original = null;
    this.editTaxTakeawayDialog.name = '';
  }

  public handleAsset(event: { venue: Venue; asset: string }) {
    if (event.venue && event.asset) {
      this.updateAsset(event.venue, event.asset);
    }
  }

  public optionArticle(item: Article) {
    this.$emit('optionArticle', { id: item._id, category: item.category });
  }

  public canToggleControlArticle(val: boolean) {
    if (val) {
      return this.$can(Permission.ARTICLE_CONTROL_DEACTIVATE);
    }
    return this.$can(Permission.ARTICLE_CONTROL_ACTIVATE);
  }

  public canToggleActivation(val: boolean) {
    if (val) {
      return this.$can(Permission.ARTICLE_DEACTIVATE);
    }
    return this.$can(Permission.ARTICLE_ACTIVATE);
  }

  public canToggleVisibility(val: boolean) {
    if (val) {
      return this.$can(Permission.ARTICLE_VISIBLE);
    }
    return this.$can(Permission.ARTICLE_HIDE);
  }

  public getCategoryNameById(article: Article): any {
    const foundCategory = this.categories.find((item: Category) => item._id === article.category);
    return foundCategory ? foundCategory.name : undefined;
  }

  public filterTagsByIds(tags: string[]) {
    const filterTags = this.tags.filter((tag: Tag) => !!tags?.find((tagId: string) => tagId === tag._id));
    return filterTags
      .map((tag: Tag) => {
        return this.$options.filters!.localized(tag.name);
      })
      .toString();
  }

  @Watch('category')
  @Emit('category')
  public onCategoryChange() {
    this.search = '';
    this.$refs.vTable.resetPagination();
    return this.category ? this.category : null;
  }

  @Watch('categories')
  public onCategoriesChange() {
    if (this.category || this.categories.length === 0) {
      return;
    }
  }

  public resetTable() {
    this.category = null;
    this.$refs.vTable.resetPagination();
  }
}
